// extracted by mini-css-extract-plugin
export default {"price":"g7-z","onSale":"h7-z","msrpLabelPrice":"i7-z","msrpLabel":"j7-z","originalPrice":"k7-z","percentOff":"l7-z"};